import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../mainHeadingAction';
import fetchApi from "./fetchApi";

function fetchMainHeadingAction() {
  return fetchApi('/v1/fc_api/main_heading_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchMainHeadingAction;
